/**
 * useBackdropDismiss — modal-backdrop 클릭 시 닫기 동작 (drag-safe).
 *
 * 문제: 모달 안에서 mousedown → 드래그 → backdrop 위에서 mouseup → click 발화 → 닫힘.
 *       (텍스트 선택, 차트 드래그 등 의도치 않은 닫힘)
 *
 * 해결: mousedown 시점에 시작 위치를 추적. 시작이 backdrop 위였고 종료도 backdrop이면 닫음.
 *       시작이 내부였다면 어디에서 mouseup이 일어나도 닫지 않음.
 *
 * Material UI / Radix UI / Headless UI가 모두 사용하는 패턴.
 *
 * 사용:
 *   const dismiss = useBackdropDismiss(onClose);
 *   <div className="modal-backdrop" {...dismiss}>
 *     <div className="modal-form" onClick={(e) => e.stopPropagation()}>
 *       ...
 *     </div>
 *   </div>
 *
 * 옵션:
 *   - disabled: true면 닫기 비활성 (busy 상태 등)
 */
import { useRef, type MouseEvent } from "react";

export interface BackdropDismissHandlers {
  onMouseDown: (e: MouseEvent<HTMLDivElement>) => void;
  onClick: (e: MouseEvent<HTMLDivElement>) => void;
}

export function useBackdropDismiss(
  onClose: () => void,
  options?: { disabled?: boolean },
): BackdropDismissHandlers {
  const startedOnBackdropRef = useRef(false);

  return {
    onMouseDown: (e) => {
      startedOnBackdropRef.current = e.target === e.currentTarget;
    },
    onClick: (e) => {
      const startedOnBackdrop = startedOnBackdropRef.current;
      startedOnBackdropRef.current = false;
      if (options?.disabled) return;
      if (startedOnBackdrop && e.target === e.currentTarget) {
        onClose();
      }
    },
  };
}
